import React, { useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';

function AlunosOnlineLoader() {
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const containerDash = document.querySelector('.item-access');
    if (!containerDash) return;

    setContainerWidth(containerDash.clientWidth);
    window.onresize = () => {
      setContainerWidth(containerDash.clientWidth);
    };
  }, []);

  return (
    <ContentLoader
      speed={1}
      width={containerWidth}
      height={152}
      backgroundColor="#eee"
      foregroundColor="#ddd"
    >
      <rect x="0" y="0" rx="25" ry="25" width={containerWidth} height="122" />
    </ContentLoader>
  );
}

export default AlunosOnlineLoader;
